<template>
  <!-- @mouseout="value = false" -->
  <v-hover>
    <template #default="hover_activator_slot">
      <div
        @click="value = true"
        @mouseleave="value = false"
        class="activator-delete"
        :style="`
          background-color: ${color};
          height: ${hover_activator_slot.hover?'20px':'8px'};
          width: ${getWidth(hover_activator_slot.hover)};
          border-radius: ${value?'3px':'100%'};
          ${value? 'margin-left: 33px':''}
          `"
      >
        <div v-if="!value" class="activator-iceberg-object" />
        <div
          v-if="value && !loading"
          class="activator-delete-element"
          @click="deleteButton()"
        >
          <TIcon name="bin-delete" small />
          <TText :text="$t('Buttons.Delete')" />
        </div>
        <div
          v-if="value && loading"
          class="activator-delete-element"
        >
          <v-progress-circular
            :size="18"
            :width="3"
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </div>
      </div>
    </template>
  </v-hover>
</template>

<script>
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TText from '@/components/Taktify/TText.component.vue';

export default {
  props: [
    'color',
  ],

  components: {
    TIcon,
    TText,
  },

  data: () => ({
    value: false,
    loading: false,
  }),

  methods: {
    getWidth(hover) {
      if (this.value) {
        return '66px'
      } else if (hover) {
        return '20px'
      } else {
        return '8px'
      }
    },

    deleteButton(){
      this.loading = true;
      this.$emit('activatorDelete');
    }
  }
}
</script>

<style>
  .activator-delete {
    position: absolute;
    display: flex;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    z-index: 2;
    background-color: white;
    transition: all 50ms ease-in-out;
    align-items: center;
    justify-content: center;
  }
  .activator-delete-element {
    display: flex;
    grid-gap: 2px;
  }
  /* .activator-delete:hover {
    height: 20px;
    width: 20px;
  } */
</style>
